export default __webpack_public_path__ + "static/media/down-arrow.73e30b48.svg";